import { render } from "./tab-two.vue?vue&type=template&id=4c1355d0&scoped=true"
import script from "./tab-two.vue?vue&type=script&lang=js"
export * from "./tab-two.vue?vue&type=script&lang=js"

import "./tab-two.vue?vue&type=style&index=0&id=4c1355d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1355d0"]])

export default __exports__